<div class="age-picker-container dropdown">
    <button
        class="btn btn-default"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        hznTestId="age-picker-toggle"
    >
        <span>
            {{ ageInner | age }}
        </span>
        <i class="fa fa-birthday-cake" aria-hidden="true"></i>
    </button>

    <div
        class="dropdown-menu age-edit-container"
        aria-labelledby="dropdownMenuButton"
        (click)="menuClicked($event)"
    >
        <div class="input-group">
            <span class="input-group-btn">
                <button
                    class="btn btn-default"
                    type="menu"
                    hznTestId="age-picker-year-down"
                    (click)="onYearDown()"
                >
                    -
                </button>
            </span>
            <input
                type="text"
                class="form-control text-center"
                value="{{ getYears() }} year(s)"
                hznTestId="age-picker-years"
                readonly
            />
            <span class="input-group-btn">
                <button
                    class="btn btn-default"
                    type="menu"
                    hznTestId="age-picker-year-up"
                    (click)="onYearUp()"
                >
                    +
                </button>
            </span>
        </div>
        @if (!yearOnly) {
            <div class="input-group voffset-10">
                <span class="input-group-btn">
                    <button class="btn" type="menu" (click)="onMonthDown()">
                        -
                    </button>
                </span>
                <input
                    type="text"
                    class="form-control text-center"
                    value="{{ getMonths() }} month(s)"
                    readonly
                />
                <span class="input-group-btn">
                    <button
                        class="btn btn-default"
                        type="menu"
                        (click)="onMonthUp()"
                    >
                        +
                    </button>
                </span>
            </div>
        }
    </div>
</div>
